import { Instagram, Phone } from "lucide-react";
import { SITE } from "../../lib/data";

/**
 * FloatingCTA — stacked WhatsApp + Call + Instagram buttons.
 * Positioned above the on-site chatbot widget (bottom-right) to avoid overlap.
 */
const WhatsAppIcon = (props) => (
  <svg viewBox="0 0 32 32" fill="currentColor" aria-hidden="true" {...props}>
    <path d="M19.11 17.27c-.27-.14-1.62-.8-1.87-.89-.25-.09-.43-.14-.62.14-.18.27-.71.89-.87 1.07-.16.18-.32.2-.59.07-.27-.14-1.15-.42-2.19-1.35-.81-.72-1.36-1.61-1.52-1.88-.16-.27-.02-.42.12-.55.12-.12.27-.32.41-.48.14-.16.18-.27.27-.45.09-.18.05-.34-.02-.48-.07-.14-.62-1.49-.85-2.04-.22-.54-.45-.47-.62-.47-.16 0-.34-.02-.52-.02-.18 0-.48.07-.73.34-.25.27-.96.94-.96 2.3 0 1.36.99 2.68 1.13 2.86.14.18 1.95 2.98 4.72 4.18.66.28 1.18.45 1.58.58.66.21 1.27.18 1.75.11.53-.08 1.62-.66 1.85-1.3.23-.64.23-1.18.16-1.3-.07-.12-.25-.18-.52-.32z"/>
    <path d="M26.6 5.4A14.86 14.86 0 0 0 16.02 1C7.74 1 1 7.74 1 16.02c0 2.64.69 5.22 2 7.5L1 31l7.66-2c2.2 1.2 4.68 1.84 7.36 1.84h.01c8.28 0 15.02-6.74 15.02-15.02 0-4.01-1.56-7.79-4.45-10.42zM16.03 28.3h-.01c-2.38 0-4.71-.64-6.74-1.85l-.48-.29-4.54 1.19 1.21-4.42-.31-.5a12.32 12.32 0 0 1-1.89-6.55c0-6.83 5.56-12.38 12.38-12.38 3.31 0 6.42 1.29 8.76 3.63a12.34 12.34 0 0 1 3.62 8.76c0 6.83-5.56 12.38-12.38 12.38z"/>
  </svg>
);

export default function FloatingCTA() {
  return (
    <div
      data-testid="floating-cta"
      className="fixed right-4 bottom-24 md:right-6 md:bottom-28 z-40 flex flex-col items-center gap-3"
    >
      <a
        data-testid="floating-whatsapp"
        href={`https://wa.me/${SITE.whatsapp}?text=${encodeURIComponent(
          "Hello Amarja Hills, I'd like to know more about your villa plots."
        )}`}
        target="_blank"
        rel="noopener noreferrer"
        aria-label="Chat on WhatsApp"
        className="w-12 h-12 md:w-14 md:h-14 rounded-full bg-[#25D366] text-white flex items-center justify-center shadow-[0_8px_28px_rgba(37,211,102,0.45)] ring-1 ring-white/20 hover:bg-[#1ebe57] transition-all duration-300 hover:scale-105"
      >
        <WhatsAppIcon className="w-6 h-6 md:w-7 md:h-7" />
      </a>
      <a
        data-testid="floating-call"
        href={`tel:${SITE.telHref}`}
        aria-label={`Call ${SITE.phone}`}
        className="w-12 h-12 md:w-14 md:h-14 rounded-full bg-[#1A362D] text-[#F7F5F0] flex items-center justify-center shadow-[0_8px_28px_rgba(10,15,12,0.28)] ring-1 ring-white/15 hover:bg-[#234a3d] transition-all duration-300 hover:scale-105"
      >
        <Phone className="w-5 h-5 md:w-[22px] md:h-[22px]" strokeWidth={1.8} />
      </a>
      <a
        data-testid="floating-instagram"
        href={SITE.instagram}
        target="_blank"
        rel="noopener noreferrer"
        aria-label="Follow Amarja Hills on Instagram"
        className="w-12 h-12 md:w-14 md:h-14 rounded-full bg-[#F7F5F0] text-[#1A362D] flex items-center justify-center shadow-[0_8px_28px_rgba(10,15,12,0.18)] ring-1 ring-[#1A362D]/10 hover:bg-[#E2CFA1] hover:text-[#1A362D] transition-all duration-300 hover:scale-105"
      >
        <Instagram className="w-5 h-5 md:w-[22px] md:h-[22px]" strokeWidth={1.6} />
      </a>
    </div>
  );
}
